export type AutoCapitalizeOptions =
  | 'characters'
  | 'words'
  | 'sentences'
  | 'none'
